import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AutoplayHandlerModule} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerModule';
import {MessagesAPI} from '@fantasmagames/slot/src/logic/relax/MessagesAPI';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {MainMenuEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents';
import {RelaxEvents} from '@fantasmagames/slot/src/integration/RelaxEvents';
import {StopAutoplayButtonEvents} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonEvents';

export class AutoplayPausedState extends ModuleState<null, AutoplayHandlerModule> {

	protected _waitingForSpin: boolean = false;

	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(MessagesAPI.GAME_RESUMED, this.onTryToRestoreAutoplay);
		this.on(MainMenuEvents.MAIN_MENU_CLOSED, this.onTryToRestoreAutoplay);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.on(StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onAutoplayStopClicked);

		this.on(RelaxEvents.SHOW_REALITY_CHECK, this.onShowRealityCheck);
	}

	protected onAutoplayStopClicked(): void {
		this.module.stopAutoplay();
		this.module.gotoState(AutoplayHandlerModule.BASIC);
	}

	protected onTryToRestoreAutoplay(): void {
		if (this._waitingForSpin && this.module.isWaitingForGameResume
			&& this.module.isWaitingForMainMenuClose) {
			this._waitingForSpin = false;

			this.module.gotoState(AutoplayHandlerModule.IN_PROGRESS);
			this.module.tryToStartSpin();
		}
	}

	protected onShowRealityCheck(): void {
		this.module.gotoState(AutoplayHandlerModule.BASIC);
	}

	protected onCanSpin(): void {
		this._waitingForSpin = true;

		this.onTryToRestoreAutoplay();
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/autoplay/states/AutoplayPausedState.ts